import { useUserRole } from "@/api";
import Loading from "@/components/ui/loading";
import { useParams } from "@tanstack/react-router";
import WordRotate from "../ui/word-rotate";
import { AdminAdviceCarousel } from "./AdminAdviceCarousel";

export const AppLoading = () => {
  const { isAdmin } = useUserRole();
  const { organizationSlug } = useParams({ strict: false });

  return (
    <div className="h-full w-full items-center justify-center flex flex-col gap-4">
      <Loading size="md" />
      <div className="px-5 text-base text-center font-extralight text-brand-gray-400 dark:text-brand-gray-200">
        <span>One minute - we&apos;re connecting you to the requested app</span>

        <WordRotate
          textItems={[
            { duration: 10000, text: "" },
            {
              text: "One minute -  we're connecting you to the requested application.",
              duration: 20000
            },
            {
              text: "We are still working on your app, please hold on.",

              duration: 40000
            },
            {
              text: "Almost there…",

              duration: 60000
            },
            {
              text: "Preparing the application is taking longer than expected. Try reloading this page. If the problem persists, please contact the application developer to resolve this issue.",
              duration: 1
            }
          ]}
          className="text-xs"
        />

        {isAdmin && organizationSlug && (
          <div className="mt-10">
            <AdminAdviceCarousel />
          </div>
        )}
      </div>
    </div>
  );
};
